const module = { name: 'fd-location/utils', exports: {} }; const exports = module.exports;



import { Fandango_cookie as cookie } from '@grins/fd-modules/splits/onering-global';



import { Fandango_sanitizer as sanitizer } from '@grins/fd-modules/splits/onering-global';



import { Fandango_geolocator as geolocator } from '@grins/fd-modules/splits/onering-global';



const Selectors = {
    ALERT_MESSAGE_ITEMS: '.js-alert-message',
    LOCATION_NAME: '.js-location-name',
    OVERLAY_BUTTON: '.js-location-overlay',
}


const Styles = {
    GLOBAL_HEADER_LOCATION: 'global-header__location-name'
}


const CookieNames = {
    AKAMAI_LOCATION: 'akamai_generated_location',
    USER_LOCATION: 'userlocation'
}


const CookieOpts = {
    domain: geolocator.getCookieDomain(),
    secure: true,
}
function setPrecision(value) {
    if (!value) {
        return null;
    }
    const numVal = parseFloat(value);
    if (isNaN(numVal)) {
        return null;
    }
    return numVal.toFixed(2);
}
function parseUserLocationCookie(cookieValue) {
    if (!cookieValue) {
        return {};
    }
    return cookieValue.split('&').reduce((acc, param) => {
        const [key, value] = param.split('=');
        acc[key] = decodeURIComponent(String(value || '').replace(/\+/g, ' '));
        return acc;
    }, {});
}
function serializeUserLocation(locationData) {
    if (!locationData) {
        return '';
    }
    return Object.keys(locationData)
        .map(key => `${key}=${encodeURIComponent(locationData[key] || '')}`)
        .join('&');
}
function getLocation() {
    const result = {};
    const rawUserLocation = cookie.get(CookieNames.USER_LOCATION);
    const userLocation = parseUserLocationCookie(sanitizer.text(rawUserLocation));
    const postal = userLocation.postal;
    let akamaiLocation = sanitizer.text(cookie.get(CookieNames.AKAMAI_LOCATION));
    if (!rawUserLocation && akamaiLocation) {
        try {
            const decoded = akamaiLocation.charAt(0) !== '{' ? decodeURIComponent(akamaiLocation) : akamaiLocation;
            akamaiLocation = JSON.parse(decoded);
        }
        catch (e) {
            akamaiLocation = null;
        }
        if (akamaiLocation) {
            const zip = typeof akamaiLocation.zip === 'string' ? akamaiLocation.zip.substr(0, 5) : '';
            Object.assign(result, {
                postalCode: zip,
                lat: setPrecision(akamaiLocation.lat),
                long: setPrecision(akamaiLocation.long),
            });
            if (!zip && akamaiLocation.city) {
                Object.assign(result, {
                    city: akamaiLocation.city,
                    region: akamaiLocation.state,
                    country: akamaiLocation.countrycode,
                });
            }
        }
    }
    if (postal) {
        result.postalCode = postal !== 'undefined' ? postal : '';
    }
    if (userLocation) {
        if (userLocation.lat && userLocation.long) {
            result.lat = userLocation.lat;
            result.long = userLocation.long;
        }
        if (userLocation.country) {
            result.country = userLocation.country;
        }
        if (userLocation.city && userLocation.region) {
            result.name = `${userLocation.city}, ${userLocation.region}`;
            result.city = userLocation.city;
            result.region = userLocation.region;
        }
        else if (userLocation.city) {
            result.name = userLocation.city;
            result.city = userLocation.city;
        }
    }
    if (result.postalCode) {
        result.zip = result.postalCode;
        result.params = {
            postalCode: result.postalCode,
            zip: result.postalCode
        };
    }
    else if (result.lat && result.long) {
        result.params = {
            lat: result.lat,
            long: result.long
        };
    }
    return result;
}
function updateLocation(location) {
    const names = document.querySelectorAll(Selectors.LOCATION_NAME);
    const buttons = document.querySelectorAll(Selectors.OVERLAY_BUTTON);
    if (!names.length) {
        return;
    }
    location = location || {};
    const value = sanitizer.text(location.zip
        || location.postalCode
        || location.name
        || (location.city && location.region ? `${location.city}, ${location.region}` : location.city || ''));
    names.forEach((el) => {
        if (value) {
            el.innerHTML = value;
            el.value = (location.zip || location.postalCode) ? value : '';
        }
        else if (!el.classList.contains(Styles.GLOBAL_HEADER_LOCATION)) {
            el.innerHTML = 'SET LOCATION';
        }
    });
    buttons.forEach((el) => {
        if (!value) {
            return;
        }
        el.setAttribute('aria-label', `Theaters near ${value}`);
    });
}
function setUserLocationCookie(location) {
    geolocator.setUserLocationCookie(location, () => { }, Object.assign({}, CookieOpts, {
        skipMismatchCheck: true,
    }));
}
module.exports = {
    getLocation,
    parseUserLocationCookie,
    serializeUserLocation,
    updateLocation,
    setUserLocationCookie,
};
export default module.exports;